import textReplyList from '@/views/automation/textReply/list'
import welcomeChatList from '@/views/automation/welcomeChat/list'
import workingChatList from '@/views/automation/workingChat/list'
import awayChatList from '@/views/automation/awayChat/list'
import homeChatList from '@/views/automation/homeChat/list'
import customByKeywords from '@/views/automation/customByKeywords/list'
import customRulesTextList from '@/views/automation/customRulesText/list'
import chatbotOverview from '@/views/ai/chatbot/overview/index.vue'
import ChatbotConfigLayout from '../../components/layouts/ChatbotConfigLayout.vue'
import chatOverview from '@/views/ai/chat/overview/index.vue'

import ai_pricing from '@/views/settings/AiListPricing'
import settings_aikeyEdit from '@/views/settings/aiKeyEdit'
import settings_aikey from '@/views/settings/aiKey'
import aiSummary from '@/views/settings/aiSummary'
import aiWorkflow from '@/views/ai/workflow/list.vue'
import ai_historykb from '@/views/settings/historykb'
import agentAiV2List from '@/views/ai/agentV2/list.vue'
import agentAiV2Wizard from '@/views/ai/agentV2/wizard.vue'
import agentAiV2Simulation from '@/views/ai/agentV2/simulation.vue'
export const chatbot = {
  path: '/ai-chatbot', // unique
  name: 'Produk', // unique
  hidden: false,
  component: ChatbotConfigLayout,
  redirect: '/ai-chatbot/overview',
  meta: {
    title: 'AI Chatbot',
    // roles:[] // di isi sesuai role jika
  },
  children: [
    {
      path: '/ai-chatbot/overview',
      name: 'ai_chatbot_overview',
      meta: {
        title: 'AI Chatbot Overview',
      },
      hidden: false,
      component: chatbotOverview,
    },
    {
      path: '/agent-ai-v2',
      name: 'agentAiV2List',
      meta: {
        title: 'Agent AI & Chatbot V2',
        roles: ['member']
      },
      hidden: false,
      component: agentAiV2List,
    },
    {
      path: '/agent-ai-v2/create',
      name: 'agentAiV2Create',
      meta: {
        title: 'Atur Agent AI & Chatbot V2',
        roles: ['member']
      },
      hidden: false,
      component: agentAiV2Wizard,
    },
    {
      path: '/agent-ai-v2/edit',
      name: 'agentAiV2Edit',
      meta: {
        title: 'Edit Agent AI & Chatbot V2',
        roles: ['member']
      },
      hidden: false,
      component: agentAiV2Wizard,
    },
    {
      path: '/agent-ai-v2/simulation',
      name: 'agentAiV2Simulation',
      meta: {
        title: 'Simulasi Agent AI & Chatbot',
        roles: ['member']
      },
      hidden: false,
      component: agentAiV2Simulation,
    },
    {
      path: '/automation/text-reply/list',
      name: 'textReplyList',
      meta: {
        title: 'Text Reply',
      },
      hidden: false,
      component: textReplyList,
    },
    {
      path: '/automation/welcome-chat/list',
      name: 'welcomeChatList',
      meta: {
        title: 'Balas Otomatis',
        roles: ['member']
      },
      hidden: false,
      component: welcomeChatList,
    },
    {
      path: '/automation/working-chat/list',
      name: 'workingChatList',
      meta: {
        title: 'Balas di Jam Kerja',
        roles: ['member']
      },
      hidden: false,
      component: workingChatList,
    },
    {
      path: '/automation/away-chat/list',
      name: 'awayChatList',
      meta: {
        title: 'Balas Diluar Jam Kerja',
        roles: ['member']
      },
      hidden: false,
      component: awayChatList,
    },
    {
      path: '/automation/home-chat/list',
      name: 'homeChatList',
      meta: {
        title: 'Home Chat',
        roles: ['member']
      },
      hidden: false,
      component: homeChatList,
    },
    {
      path: '/automation/custom-by-keywords-chat/list',
      name: 'customByKeywords',
      meta: {
        title: 'Balas Berdasarkan Kata Kunci',
        roles: ['member']
      },
      hidden: false,
      component: customByKeywords,
    },
    {
      path: '/automation/custom-rules-text/list',
      name: 'customRulesText',
      meta: {
        title: 'Alur Percakapan',
        roles: ['member']
      },
      hidden: false,
      component: customRulesTextList,
    },
    {
      path: '/ai-chat/overview',
      name: 'ai_chat_overview',
      meta: {
        title: 'AI Chat Overview',
      },
      hidden: false,
      component: chatOverview,
    },
    {
      hidden: false,
      meta: {
        title: 'Sesi AI Chat',
      },
      path: '/aikey',
      name: 'settings_aikey',
      component: settings_aikey,
    },
    {
      hidden: false,
      meta: {
        title: 'Rangkuman AI',
      },
      path: '/aisummary',
      name: 'ai_summary',
      component: aiSummary,
    },
    {
      hidden: false,
      meta: {
        title: 'Workflow AI',
      },
      path: '/ai/workflow',
      name: 'ai_workflow',
      component: aiWorkflow,
    },

    {
      hidden: false,
      meta: {
        title: 'Knowledge Base',
      },
      path: '/ai/historykb',
      name: 'ai_historykb',
      component: ai_historykb,
    },
    {
      hidden: false,
      meta: {
        title: 'Harga Token AI',
      },
      path: '/ai/pricing',
      name: 'ai_pricing',
      component: ai_pricing,
    },
  ]
}
// export const chatbot =

export default chatbot



// WEBPACK FOOTER //
// ./src/router/modules/ai_chatbot.js